import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MainFacade } from '../pages/main.facade';

@Component({
  selector: 'app-recentbuy',
  templateUrl: './recentbuy.component.html',
  styleUrls: ['./recentbuy.component.scss']
})
export class RecentbuyComponent implements OnInit {

  public recentBuy$: Observable<any>|undefined;
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.createSubscriptions();
  }

  createSubscriptions(){
    this.recentBuy$ = this.mainfacade.recentBuy$;
    //this.mainfacade.getTopSpenders();
  }

}
